import { AmenityResponse, LegacyAmenity, CategoryResponse } from '~/models'
import { $axios } from '~/utils/api'

const PATH = `${process.env.xplorerBaseurl}/api/PointOfInterest`
const POIS_ENDPOINT = `${PATH}/Search?Page=<page>&PageSize=<PageSize>&xoslug=<slug>&q=<search>&categoryIds=<category>`
const CATEGORIES_ENDPOINT = `${PATH}/Categories?Page=1&PageSize=100&xoslug=<slug>`
const LEGACY_POIS_ENDPOINT = '/poi'

const getAllAmenities = ({
  slug,
  search = '',
  category = '',
  page = 1,
  pageSize = 100,
}: {
  slug: string
  search: string
  category: string
  page?: number
  pageSize?: number
}): Promise<AmenityResponse> =>
  $axios.$get(
    `${POIS_ENDPOINT}`
      .replace('<slug>', slug)
      .replace('<page>', page.toString())
      .replace('<PageSize>', pageSize.toString())
      .replace('<search>', search)
      .replace('<category>', category)
  )
const getPoiCategories = ({
  slug,
}: {
  slug: string
}): Promise<CategoryResponse> =>
  $axios.$get(`${CATEGORIES_ENDPOINT}`.replace('<slug>', slug))

const getLegacyXOAmenities = (): Promise<Array<LegacyAmenity>> =>
  $axios.$get(`${LEGACY_POIS_ENDPOINT}`)

export { getAllAmenities, getPoiCategories, getLegacyXOAmenities }
